module.exports = __webpack_public_path__ + "img/card-image.b2dd408f.png";